import { render, staticRenderFns } from "./QuickRecap.vue?vue&type=template&id=1e5040c6&scoped=true&"
import script from "./QuickRecap.vue?vue&type=script&lang=js&"
export * from "./QuickRecap.vue?vue&type=script&lang=js&"
import style0 from "./QuickRecap.vue?vue&type=style&index=0&id=1e5040c6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5040c6",
  null
  
)

export default component.exports